import { render, staticRenderFns } from "./accountCllect.vue?vue&type=template&id=dcba8076&scoped=true&"
import script from "./accountCllect.vue?vue&type=script&lang=js&"
export * from "./accountCllect.vue?vue&type=script&lang=js&"
import style0 from "./accountCllect.vue?vue&type=style&index=0&id=dcba8076&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcba8076",
  null
  
)

export default component.exports